(() => {
  function init() {
    const root = document.querySelector('.huh-home-conversion');
    if (!root || root.dataset.homeInitialized) return;
    root.dataset.homeInitialized = 'true';
    document.body.classList.add('huh-home-draft');
    const header = document.querySelector('.site-header-sticky-wrapper');
    const measure = () => {
      const height = header && getComputedStyle(header).position === 'fixed' ? header.offsetHeight : 0;
      root.style.setProperty('--huh-header-height', `${height}px`);
    };
    measure();
    if (header && 'ResizeObserver' in window) new ResizeObserver(measure).observe(header);
    window.addEventListener('resize', measure, {passive: true});
    const track = root.querySelector('.huh-review-track');
    if (track) {
      const cards = Array.from(track.querySelectorAll('[data-review-topic]'));
      const filters = Array.from(root.querySelectorAll('[data-review-filter]'));
      const previous = root.querySelector('[data-review-prev]');
      const next = root.querySelector('[data-review-next]');
      const status = root.querySelector('[data-review-status]');
      const visibleCards = () => cards.filter(card => !card.hidden);
      const step = () => {
        const visible = visibleCards();
        return visible.length > 1 ? visible[1].offsetLeft - visible[0].offsetLeft : track.clientWidth;
      };
      const updateReviews = () => {
        const visible = visibleCards();
        const gap = parseFloat(getComputedStyle(track).columnGap) || 16;
        const first = Math.min(visible.length, Math.round(track.scrollLeft / Math.max(1, step())) + 1);
        const shown = Math.max(1, Math.floor((track.clientWidth + gap + 2) / Math.max(1, step())));
        const last = Math.min(visible.length, first + shown - 1);
        previous.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        status.textContent = `${first === last ? first : `${first}–${last}`} of ${visible.length}`;
      };
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const move = direction => track.scrollBy({left: direction * step(), behavior: reducedMotion ? 'auto' : 'smooth'});
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      filters.forEach(filter => filter.addEventListener('click', () => {
        const topic = filter.dataset.reviewFilter;
        filters.forEach(item => item.setAttribute('aria-pressed', String(item === filter)));
        cards.forEach(card => {
          card.hidden = topic !== 'all' && card.dataset.reviewTopic !== topic;
          if (card.hidden) card.querySelector('video')?.pause();
        });
        track.scrollTo({left: 0, behavior: 'auto'});
        updateReviews();
      }));
      track.addEventListener('scroll', updateReviews, {passive: true});
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') track.scrollTo({left: event.key === 'Home' ? 0 : track.scrollWidth, behavior: 'auto'});
        else move(event.key === 'ArrowLeft' ? -1 : 1);
      });
      if ('ResizeObserver' in window) new ResizeObserver(updateReviews).observe(track);
      updateReviews();
    }
    const parentPreview = root.querySelector('[data-parent-preview]');
    if (parentPreview) {
      const card = parentPreview.closest('[data-review-topic]');
      const pauseButton = root.querySelector('[data-parent-pause]');
      const watchButton = root.querySelector('[data-parent-watch]');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      let fullStory = false;
      let userPaused = reduced;
      let fallbackUsed = false;
      const updateParentButton = () => {
        pauseButton.textContent = parentPreview.paused ? 'Play' : 'Pause';
        pauseButton.setAttribute('aria-label', `${parentPreview.paused ? 'Play' : 'Pause'} parent preview`);
      };
      const playParent = () => parentPreview.play().catch(updateParentButton);
      const syncParent = () => {
        if (card.hidden || document.hidden) parentPreview.pause();
        else if (!fullStory && !userPaused) playParent();
      };
      parentPreview.muted = true;
      parentPreview.defaultMuted = true;
      if (reduced) {
        parentPreview.autoplay = false;
        parentPreview.pause();
      } else playParent();
      parentPreview.addEventListener('play', updateParentButton);
      parentPreview.addEventListener('pause', updateParentButton);
      pauseButton.addEventListener('click', () => {
        userPaused = !parentPreview.paused;
        if (userPaused) parentPreview.pause();
        else playParent();
      });
      watchButton.addEventListener('click', () => {
        fullStory = true;
        parentPreview.pause();
        parentPreview.src = parentPreview.dataset.fullSrc;
        parentPreview.loop = false;
        parentPreview.muted = false;
        parentPreview.controls = true;
        parentPreview.setAttribute('aria-label', 'HeadsUpHockey parent testimonial');
        pauseButton.hidden = true;
        watchButton.hidden = true;
        parentPreview.load();
        playParent();
      });
      parentPreview.addEventListener('error', () => {
        if (fullStory && !fallbackUsed) {
          fallbackUsed = true;
          parentPreview.src = parentPreview.dataset.fullFallback;
          parentPreview.load();
          playParent();
        } else updateParentButton();
      });
      root.querySelectorAll('[data-review-filter]').forEach(button => button.addEventListener('click', syncParent));
      document.addEventListener('visibilitychange', syncParent);
      updateParentButton();
    }
    const video = root.querySelector('.cover-video');
    const button = root.querySelector('.huh-hero-pause');
    if (video && button) {
      const update = () => {
        button.textContent = video.paused ? 'Play video' : 'Pause video';
        button.setAttribute('aria-label', `${video.paused ? 'Play' : 'Pause'} background video`);
        button.setAttribute('aria-pressed', String(video.paused));
      };
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
        video.autoplay = false;
        video.pause();
      }
      video.addEventListener('play', update);
      video.addEventListener('pause', update);
      button.addEventListener('click', () => {
        if (video.paused) video.play().catch(update);
        else video.pause();
      });
      update();
    }
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
